import React, { useEffect, useState } from "react";
import { isAiFeaturesEnabled } from "config/aiFeatureFlags";
import { REFRESH_PERMISSIONS_EVENT } from "helpers/RolesPermission";
import {
  readOrgAiFromServiceProvider,
  resolveTimesheetAiAccess,
  SP_SETTINGS_AI_UPDATED_EVENT,
} from "helpers/spAiFeatureAccess";
import { IconExternalLink, IconRefresh } from "./CareWatchIcons";

const canReanalyse = () => {
  if (!isAiFeaturesEnabled) return false;
  const org = readOrgAiFromServiceProvider();
  if (!org) return false;
  return resolveTimesheetAiAccess(org).canAnalyse;
};

const CareWatchTimesheetTools = ({
  onOpenTimesheet,
  onReanalyse,
  reanalyseLoading = false,
}) => {
  const [showReanalyse, setShowReanalyse] = useState(canReanalyse);

  useEffect(() => {
    const refresh = () => setShowReanalyse(canReanalyse());
    window.addEventListener(SP_SETTINGS_AI_UPDATED_EVENT, refresh);
    window.addEventListener(REFRESH_PERMISSIONS_EVENT, refresh);
    return () => {
      window.removeEventListener(SP_SETTINGS_AI_UPDATED_EVENT, refresh);
      window.removeEventListener(REFRESH_PERMISSIONS_EVENT, refresh);
    };
  }, []);

  return (
  <div className="care-watch-timesheet-tools">
    <p className="care-watch-detail-box-title">Timesheet</p>
    <div className="care-watch-timesheet-tools__row">
      <button
        type="button"
        onClick={onOpenTimesheet}
        className="care-watch-timesheet-tile care-watch-timesheet-tile--open"
      >
        <IconExternalLink size={14} stroke="#4B6CB7" />
        <span>Open timesheet</span>
      </button>
      {showReanalyse ? (
      <button
        type="button"
        onClick={onReanalyse}
        disabled={reanalyseLoading}
        className="care-watch-timesheet-tile care-watch-timesheet-tile--reanalyse disabled:opacity-50"
      >
        <IconRefresh
          size={14}
          stroke="#FFFFFF"
          className={reanalyseLoading ? "care-watch-timesheet-tile__spin" : ""}
        />
        <span>{reanalyseLoading ? "Analysing…" : "Re-analyse"}</span>
      </button>
      ) : null}
    </div>
  </div>
  );
};

export default CareWatchTimesheetTools;
